import React, { useEffect, useState } from 'react';

import { IconButton } from '@mui/material';
import { Verified, CancelOutlined, Warning, Close, InfoOutlined } from '@mui/icons-material';

import './customToaster.css';
import { useToast } from './toastContext';
import { Colors } from '../config/default';

const CustomToaster = () => {
  const { toast, hideToast } = useToast();
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    let timer;
    if (toast && toast.variant !== 'error' && !isHovered) {
      timer = setTimeout(() => {
        hideToast();
      }, 3000);
    }

    return () => clearTimeout(timer);
  }, [toast, hideToast, isHovered]);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  if (!toast) {
    return null;
  }

  const toastClass = toast.variant;

  const handleRemove = () => {
    setIsHovered(false);
  };

  return (
    <div
      className={`custom-toaster ${toastClass}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <div className={`custom-toaster-content ${toastClass}`}>
        {toastClass === 'error' && <CancelOutlined sx={{ color: Colors.RED, fontSize: '2.2em' }} />}
        {toastClass === 'success' && <Verified sx={{ color: Colors.LIGHTBLUE, fontSize: '2em' }} />}
        {toastClass === 'warning' && <Warning sx={{ color: Colors.YELLOW, fontSize: '2em' }} />}
        {toastClass === 'info' && <InfoOutlined sx={{ color: Colors.DEEPBLUE, fontSize: '2em' }} />}
      </div>

      <span className="custom-toaster-message">{toast.message}</span>
      <IconButton
        onClick={() => {
          hideToast();
          handleRemove();
        }}
        sx={{
          position: 'absolute',
          right: 47,
          top: 3,
          transform: 'translate(1.8em,0px)',
          cursor: 'pointer'
        }}>
        <Close sx={{ color: Colors.WHITE, fontSize: '.8em' }} />
      </IconButton>
    </div>
  );
};

export default CustomToaster;
